import { render } from "./TalleresAnualPage.vue?vue&type=template&id=0b63da75&scoped=true"
import script from "./TalleresAnualPage.vue?vue&type=script&lang=js"
export * from "./TalleresAnualPage.vue?vue&type=script&lang=js"

import "./TalleresAnualPage.vue?vue&type=style&index=0&id=0b63da75&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b63da75"]])

export default __exports__